import { useTranslation } from "@opendash/i18n";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../context/PathContext";
import { ConfigInputProps } from "../../types/Config";

type Props = {} & ConfigInputProps<"project">;

export const ProjectConfigInput = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return <></>;
});
